// extracted by mini-css-extract-plugin
module.exports = {"numberInput":"NumberInput_numberInput__D_zV4","stepper":"NumberInput_stepper__AYSMS"};